import React from 'react';

const NotificationsPage = () => {
  return (
    <React.Fragment>
      <h1>this is Notifications Page</h1>
    </React.Fragment>
  );
};
export default NotificationsPage;
